export const post = (form) => {
  return fetch("https://formspree.io/f/mjvjdyqa", {
    method: 'post',
    body: JSON.stringify(form),
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response.json()
      }
    )
}



/** WEBPACK FOOTER **
 ** ./src/services/emailServices.js
 **/